import React from "react";
import RichText from "./RichText";

const BudgetHistogram = ({ budget }) => {
  if (!budget) return null;
  return (
    <div className="abr-card is-white">
      <div className="abr-card-title">Budget patterns</div>
      <p className="abr-card-sub">
        Where matched buyers concentrate their budgets &middot; midpoint of (Budget_mn + Budget_mx).
      </p>
      <svg
        viewBox="0 0 320 100"
        width="100%"
        height="120"
        role="img"
        aria-label={`Budget histogram for matched buyers; ask marker at ${budget.askDisplay}`}
      >
        <g transform="translate(8, 14)">
          {budget.askX != null && (
            <>
              <text
                x={Math.min(Math.max(budget.askX, 32), 268)}
                y="-4"
                className="abr-annot"
                textAnchor="middle"
                fill="#2D5F73"
                fontWeight="700"
                fontSize="9"
              >
                Ask &middot; {budget.askDisplay}
              </text>
              <line x1={budget.askX} y1="0" x2={budget.askX} y2="70" stroke="#2D5F73" strokeWidth="1" />
            </>
          )}
          <line x1="0" y1="70" x2="300" y2="70" stroke="#D1D5DB" strokeWidth="0.5" />
          {budget.bars.map((bar, idx) => (
            <rect
              key={idx}
              x={bar.x}
              y={70 - bar.height}
              width={bar.width || 38}
              height={bar.height}
              fill={bar.accent ? "#2D5F73" : "rgba(42,47,59,0.30)"}
              rx="1.5"
            />
          ))}
          <g className="abr-axis-tick" textAnchor="middle" fontSize="8">
            {budget.axis.map((tick, idx) => (
              <text key={idx} x={tick.x} y="83">
                {tick.label}
              </text>
            ))}
          </g>
        </g>
      </svg>
      <RichText as="p" className="abr-insight-caption" text={budget.caption} />
    </div>
  );
};

export default BudgetHistogram;
